<!-- 文档展示组件 -->
<template>
    <div>
        <el-empty :description="title+'为空'" v-if="!Descript && Images.length<=0"></el-empty>
        <div v-else class="pdl40">
            <div v-if="Images.length>0">
                <el-carousel :autoplay="false" height="400px">
                    <el-carousel-item v-for="(image,index) in Images" :key="index">
                        <el-container>
                            <el-main style="text-align:center">
                                <el-image :src="image" :preview-src-list="Images">>
                                </el-image>
                            </el-main>
                        </el-container>

                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-if="Descript" v-html="Descript" class="mgt20"></div>
        </div>
    </div>
</template>

<script>
/**
 * 文档展示
 */
export default {
    name: 'document-word',
    props: {
        title: {
            Type: String,
            default: '指标数据'
        },
        encoderId: {
            Type: String,
            default: ''
        }
    },
    data() {
        return {
            Images: [],
            Descript: ''
        }
    },
    watch: {
        encoderId: {
            handler(val) {
                if (val) {
                    console.log('dcoument-word', this.encoderId)
                    this.loadData()
                }
            },
            immediate: true
        }
    },
    methods: {
        loadData() {
            this.$request('encoder', 'report', {
                encoderId: this.encoderId
            })
                .then(res => {
                    if (res.code === 1) {
                        this.Images = res.data.Images
                            ? res.data.Images.split(',')
                            : []
                        this.Descript = res.data.Descript
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }
}
</script>
<style lang='scss' scoped>
</style>
